'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconWithBackground = require('./IconWithBackground');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconWithBackground).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/IconWithBackground/index.js
// module id = 1208
// module chunks = 1